import { render, staticRenderFns } from "./Rockall.vue?vue&type=template&id=19cf83d8&scoped=true"
import script from "./Rockall.vue?vue&type=script&lang=js"
export * from "./Rockall.vue?vue&type=script&lang=js"
import style0 from "./Rockall.vue?vue&type=style&index=0&id=19cf83d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cf83d8",
  null
  
)

export default component.exports